import { render, staticRenderFns } from "./DiagnosisForm.vue?vue&type=template&id=56077c59&scoped=true"
import script from "./DiagnosisForm.vue?vue&type=script&lang=js"
export * from "./DiagnosisForm.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisForm.vue?vue&type=style&index=0&id=56077c59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56077c59",
  null
  
)

export default component.exports